export const DISPLAY_MODE_BINOM = "Binom";
export const DISPLAY_MODE_FACEBOOK = "Facebook";
export const DISPLAY_MODE_APPSFLYER = "AppsFlyer";
